export function Toggle({ checked = false, disabled = false, label, onChange }) {
  const handleChange = () => {
    if (!disabled) onChange?.(!checked);
  };

  return (
    <label className={`flex min-h-11 w-full items-center justify-between gap-4 border border-white/10 bg-black/20 px-3.5 py-2.5 transition ${disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer hover:border-white/15'}`}>
      <span className="text-sm font-medium text-slate-200">{label}</span>
      <input
        className="sr-only"
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
      />
      <span
        aria-hidden="true"
        className={`relative h-6 w-11 shrink-0 border transition ${checked ? 'border-cyan-300/60 bg-cyan-300/20 shadow-[0_0_20px_rgba(103,232,249,.12)]' : 'border-white/15 bg-white/[.045]'}`}
      >
        <span className={`absolute top-1/2 size-4 -translate-y-1/2 transition ${checked ? 'left-6 bg-cyan-200' : 'left-1 bg-slate-500'}`}/>
      </span>
    </label>
  );
}
